import React from "react";

function LineButton({ onClick, isLoading, children, type, className }) {
  return (
    <button
      type={type}
      className={`${className} line_btn mbot-btn-primary center-alignment`}
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? <span className="loader"></span> : children}
    </button>
  );
}

export default LineButton;
